export const translations = {
  sq: {
    // Layout & Nav
    logout: 'Dil',
    home: 'Paneli',
    devices: 'Pajisjet',
    alarms: 'Alarmet',
    reports: 'Raportet',
    routineCheck: 'Kontrolli Rutinor',
    map: 'Harta',
    control: 'Kontrolli',
    companies: 'Kompanitë',
    users: 'Përdoruesit',
    regions: 'Regjionet',
    une: 'Unë',
    settings: 'Cilësimet',
    about: 'Rreth',
    alarmSetup: 'Setup Alarmeve',

    // Login
    loginTitle: 'Kyçu',
    loginSubtitle: 'Shkruaj kredencialet për të vazhduar',
    username: 'Përdoruesi',
    passwordLabel: 'Fjalëkalimi',
    rememberCreds: 'Ruaj kredencialet',
    loginBtn: 'Kyçu',
    loggingIn: 'Duke u kyçur...',
    errorNetwork: 'Lidhja me serverin dështoi.',
    errorLogin: 'Gabim gjatë kyçjes. Provoni përsëri.',
    toggleThemeLabel: 'Ndrysho light/dark',

    // Common
    loading: 'Duke ngarkuar...',
    cancel: 'Anulo',
    save: 'Ruaj',
    close: 'Mbyll',
    delete: 'Fshi',
    edit: 'Ndrysho',
    add: 'Shto',
    apply: 'Apliko',
    search: 'Kërko',
    back: 'Kthehu',
    confirm: 'A je i sigurt?',
    errorGeneric: 'Gabim',
    password: 'Fjalëkalim',
    noData: 'Nuk ka të dhëna',
    online: 'Online',
    offline: 'Offline',
    status: 'Statusi',
    actions: 'Veprime',
    active: 'Aktive',
    inactive: 'Joaktive',
    name: 'Emri',
    description: 'Përshkrimi',
    address: 'Adresa',
    phone: 'Telefoni',
    email: 'Emaili',
    select: 'Zgjidh',

    // Dashboard
    dashboardTitle: 'Paneli Kryesor',
    totalSensors: 'Gjithsej Sensorë',
    onlineSensors: 'Online',
    offlineSensors: 'Offline',
    activeAlarms: 'Alarme Aktive',
    warningAlarms: 'Paralajmërime',
    criticalAlarms: 'Alarme',
    avgTemperature: 'Temp. Mesatare',
    avgHumidity: 'Lagështia Mesatare',
    recentAlarms: 'Alarmet e fundit',
    monitoringPoints: 'Pikat e Monitorimit',
    noAlarms: 'Nuk ka alarme aktive',
    last24h: 'Grafiku 24 orë',

    // Devices
    dataLogger: 'Data Logger',
    dataLoggers: 'Data Loggerët',
    sensor: 'Sensor',
    sensors: 'Sensorët',
    addDataLogger: 'Shto Data Logger',
    addSensor: 'Shto Sensor',
    editDataLogger: 'Ndrysho Data Logger',
    editSensor: 'Ndrysho Sensor',
    serialNumber: 'Nr. Serial',
    port: 'Porta (RS485)',
    baudRate: 'Baud Rate',
    unitId: 'Unit ID',
    temperature: 'Temperatura',
    humidity: 'Lagështia',
    lastReading: 'Leximi i fundit',
    sensorType: 'Lloji i Sensorit',
    selectDataLogger: 'Zgjidh Data Logger',
    noSensors: 'Nuk ka sensorë',
    noDataLoggers: 'Nuk ka data loggerë',
    coordinates: 'Koordinatat',
    latitude: 'Gjerësia (Lat)',
    longitude: 'Gjatësia (Lng)',

    // Map
    mapTitle: 'Harta e Monitorimit',
    selectRegion: 'Zgjidh Regjionin',
    allRegions: 'Të gjitha regjionet',
    mapPoints: 'Pikat në hartë',
    zoomToRegion: 'Zoom te regjioni',
    noCoordinates: 'Pa koordinata',
    alarmPoint: 'Pika me alarm',
    warningPoint: 'Pika me paralajmërim',

    // Alarms
    alarmType: 'Lloji i Alarmit',
    severity: 'Niveli',
    value: 'Vlera',
    threshold: 'Limiti',
    message: 'Mesazhi',
    resolved: 'Zgjidhur',
    unresolved: 'Pa zgjidhur',
    resolveAlarm: 'Zgjidh Alarmin',
    resolveAll: 'Zgjidh Të Gjitha',
    HIGH_TEMP: 'Temperatura e lartë',
    LOW_TEMP: 'Temperatura e ulët',
    HIGH_HUMIDITY: 'Lagështia e lartë',
    LOW_HUMIDITY: 'Lagështia e ulët',
    SENSOR_OFFLINE: 'Sensori offline',
    WARNING: 'Paralajmërim',
    ALARM: 'Alarm',
    CRITICAL: 'Kritik',

    // Alarm Setup
    alarmSetupTitle: 'Setup i Alarmeve',
    tempHighAlarm: 'Temp. max ALARM (°C)',
    tempLowAlarm: 'Temp. min ALARM (°C)',
    tempHighWarning: 'Temp. max WARNING (°C)',
    tempLowWarning: 'Temp. min WARNING (°C)',
    humHighAlarm: 'Lagështia max ALARM (%)',
    humLowAlarm: 'Lagështia min ALARM (%)',
    humHighWarning: 'Lagështia max WARNING (%)',
    humLowWarning: 'Lagështia min WARNING (%)',
    emailNotifications: 'Njoftim me Email',
    alarmTypesToNotify: 'Llojet e Alarmeve',
    emailRecipients: 'Adresat Email',
    saveAlarmSetup: 'Ruaj Setup',
    addEmailRecipient: 'Shto Email',

    // Control
    controlTitle: 'Kontrolli i Parametrave',
    controlSubtitle: 'Vendos limitet e temperaturës dhe lagështisë për secilën pajisje',
    setParameters: 'Vendos Parametrat',
    parametersUpdated: 'Parametrat u përditësuan',

    // Users
    firstName: 'Emri',
    lastName: 'Mbiemri',
    role: 'Roli',
    addUser: 'Shto Përdorues',
    editUser: 'Ndrysho Përdoruesin',
    SUPERADMIN: 'Super Admin',
    AVUK: 'Avuk',
    KRYEINSPEKTORI: 'Kryeinspektori',
    INSPEKTORI: 'Inspektori',
    KOMPANIA: 'Kompania',
    assignRegions: 'Cakto Regjionet',
    assignCompanies: 'Cakto Kompanitë',
    userCreated: 'Përdoruesi u krijua',
    userUpdated: 'Përdoruesi u përditësua',
    userDeleted: 'Përdoruesi u fshi',

    // Companies
    addCompany: 'Shto Kompani',
    editCompany: 'Ndrysho Kompaninë',
    companyName: 'Emri i Kompanisë',
    assignRegion: 'Cakto Regjionin',
    companyCreated: 'Kompania u krijua',
    companyUpdated: 'Kompania u përditësua',
    companyDeleted: 'Kompania u fshi',

    // Regions
    addRegion: 'Shto Regjion',
    editRegion: 'Ndrysho Regjionin',
    parentRegion: 'Regjioni Prind',
    regionCreated: 'Regjioni u krijua',
    regionUpdated: 'Regjioni u përditësua',

    // Reports
    reportsTitle: 'Raportet',
    generateReport: 'Gjenero Raport',
    reportType: 'Lloji i Raportit',
    dateFrom: 'Nga Data',
    dateTo: 'Deri Data',
    downloadPDF: 'Shkarko PDF',
    sendEmail: 'Dërgo me Email',
    reportReadings: 'Leximet',
    reportAlarms: 'Alarmet',
    reportSummary: 'Përmbledhje',
    selectSensors: 'Zgjidh Sensorët',
    generating: 'Duke gjeneruar...',
    emailSent: 'Emaili u dërgua',

    // Simulate
    simulate: 'Simuloni Të Dhëna',
    simulateDesc: 'Gjenero të dhëna simulate 24h për testim',
    simulateBtn: 'Gjenero Simulate',

    // Settings
    changePassword: 'Ndrysho Fjalëkalimin',
    currentPassword: 'Fjalëkalimi Aktual',
    newPassword: 'Fjalëkalim i Ri',
    confirmNewPassword: 'Konfirmo Fjalëkalimin',
    passwordChanged: 'Fjalëkalimi u ndryshua',
    passwordMismatch: 'Fjalëkalimet nuk përputhen',

    // Language
    languageLabel: 'Gjuha',
    themeLabel: 'Pamja',
    themeDark: 'E errët',
    themeLight: 'E ndritur',
    connections: 'Lidhjet',
    aboutApp: 'Rreth Aplikacionit',
    systemSettings: 'Cilësimet e Sistemit',
    navKosova: 'HARTA',
  },

  en: {
    logout: 'Logout',
    home: 'Dashboard',
    devices: 'Devices',
    alarms: 'Alarms',
    reports: 'Reports',
    routineCheck: 'Routine Check',
    map: 'Map',
    control: 'Control',
    companies: 'Companies',
    users: 'Users',
    regions: 'Regions',
    une: 'More',
    settings: 'Settings',
    about: 'About',
    alarmSetup: 'Alarm Setup',

    loginTitle: 'Sign In',
    loginSubtitle: 'Enter your credentials to continue',
    username: 'Username',
    passwordLabel: 'Password',
    rememberCreds: 'Remember me',
    loginBtn: 'Sign In',
    loggingIn: 'Signing in...',
    errorNetwork: 'Connection to server failed.',
    errorLogin: 'Invalid credentials. Try again.',
    toggleThemeLabel: 'Toggle light/dark',

    loading: 'Loading...',
    cancel: 'Cancel',
    save: 'Save',
    close: 'Close',
    delete: 'Delete',
    edit: 'Edit',
    add: 'Add',
    apply: 'Apply',
    search: 'Search',
    back: 'Back',
    confirm: 'Are you sure?',
    errorGeneric: 'Error',
    password: 'Password',
    noData: 'No data',
    online: 'Online',
    offline: 'Offline',
    status: 'Status',
    actions: 'Actions',
    active: 'Active',
    inactive: 'Inactive',
    name: 'Name',
    description: 'Description',
    address: 'Address',
    phone: 'Phone',
    email: 'Email',
    select: 'Select',

    dashboardTitle: 'Main Dashboard',
    totalSensors: 'Total Sensors',
    onlineSensors: 'Online',
    offlineSensors: 'Offline',
    activeAlarms: 'Active Alarms',
    warningAlarms: 'Warnings',
    criticalAlarms: 'Alarms',
    avgTemperature: 'Avg Temperature',
    avgHumidity: 'Avg Humidity',
    recentAlarms: 'Recent Alarms',
    monitoringPoints: 'Monitoring Points',
    noAlarms: 'No active alarms',
    last24h: '24h Chart',

    dataLogger: 'Data Logger',
    dataLoggers: 'Data Loggers',
    sensor: 'Sensor',
    sensors: 'Sensors',
    addDataLogger: 'Add Data Logger',
    addSensor: 'Add Sensor',
    editDataLogger: 'Edit Data Logger',
    editSensor: 'Edit Sensor',
    serialNumber: 'Serial Number',
    port: 'Port (RS485)',
    baudRate: 'Baud Rate',
    unitId: 'Unit ID',
    temperature: 'Temperature',
    humidity: 'Humidity',
    lastReading: 'Last Reading',
    sensorType: 'Sensor Type',
    selectDataLogger: 'Select Data Logger',
    noSensors: 'No sensors',
    noDataLoggers: 'No data loggers',
    coordinates: 'Coordinates',
    latitude: 'Latitude',
    longitude: 'Longitude',

    mapTitle: 'Monitoring Map',
    selectRegion: 'Select Region',
    allRegions: 'All regions',
    mapPoints: 'Map points',
    zoomToRegion: 'Zoom to region',
    noCoordinates: 'No coordinates',
    alarmPoint: 'Alarm point',
    warningPoint: 'Warning point',

    alarmType: 'Alarm Type',
    severity: 'Severity',
    value: 'Value',
    threshold: 'Threshold',
    message: 'Message',
    resolved: 'Resolved',
    unresolved: 'Unresolved',
    resolveAlarm: 'Resolve',
    resolveAll: 'Resolve All',
    HIGH_TEMP: 'High Temperature',
    LOW_TEMP: 'Low Temperature',
    HIGH_HUMIDITY: 'High Humidity',
    LOW_HUMIDITY: 'Low Humidity',
    SENSOR_OFFLINE: 'Sensor Offline',
    WARNING: 'Warning',
    ALARM: 'Alarm',
    CRITICAL: 'Critical',

    alarmSetupTitle: 'Alarm Setup',
    tempHighAlarm: 'Max Temp ALARM (°C)',
    tempLowAlarm: 'Min Temp ALARM (°C)',
    tempHighWarning: 'Max Temp WARNING (°C)',
    tempLowWarning: 'Min Temp WARNING (°C)',
    humHighAlarm: 'Max Humidity ALARM (%)',
    humLowAlarm: 'Min Humidity ALARM (%)',
    humHighWarning: 'Max Humidity WARNING (%)',
    humLowWarning: 'Min Humidity WARNING (%)',
    emailNotifications: 'Email Notifications',
    alarmTypesToNotify: 'Alarm Types',
    emailRecipients: 'Email Recipients',
    saveAlarmSetup: 'Save Setup',
    addEmailRecipient: 'Add Email',

    controlTitle: 'Parameter Control',
    controlSubtitle: 'Set temperature and humidity limits per device',
    setParameters: 'Set Parameters',
    parametersUpdated: 'Parameters updated',

    firstName: 'First Name',
    lastName: 'Last Name',
    role: 'Role',
    addUser: 'Add User',
    editUser: 'Edit User',
    SUPERADMIN: 'Super Admin',
    AVUK: 'Avuk',
    KRYEINSPEKTORI: 'Chief Inspector',
    INSPEKTORI: 'Inspector',
    KOMPANIA: 'Company',
    assignRegions: 'Assign Regions',
    assignCompanies: 'Assign Companies',
    userCreated: 'User created',
    userUpdated: 'User updated',
    userDeleted: 'User deleted',

    addCompany: 'Add Company',
    editCompany: 'Edit Company',
    companyName: 'Company Name',
    assignRegion: 'Assign Region',
    companyCreated: 'Company created',
    companyUpdated: 'Company updated',
    companyDeleted: 'Company deleted',

    addRegion: 'Add Region',
    editRegion: 'Edit Region',
    parentRegion: 'Parent Region',
    regionCreated: 'Region created',
    regionUpdated: 'Region updated',

    reportsTitle: 'Reports',
    generateReport: 'Generate Report',
    reportType: 'Report Type',
    dateFrom: 'From Date',
    dateTo: 'To Date',
    downloadPDF: 'Download PDF',
    sendEmail: 'Send by Email',
    reportReadings: 'Readings',
    reportAlarms: 'Alarms',
    reportSummary: 'Summary',
    selectSensors: 'Select Sensors',
    generating: 'Generating...',
    emailSent: 'Email sent',

    simulate: 'Simulate Data',
    simulateDesc: 'Generate 24h simulated data for testing',
    simulateBtn: 'Generate Simulation',

    changePassword: 'Change Password',
    currentPassword: 'Current Password',
    newPassword: 'New Password',
    confirmNewPassword: 'Confirm Password',
    passwordChanged: 'Password changed',
    passwordMismatch: 'Passwords do not match',

    languageLabel: 'Language',
    themeLabel: 'Theme',
    themeDark: 'Dark',
    themeLight: 'Light',
    connections: 'Connections',
    aboutApp: 'About App',
    systemSettings: 'System Settings',
    navKosova: 'MAP',
  }
};

export const defaultLanguage = 'sq';
